/**
 * Module: Partner Swiper Slider
 * Description: Inizializza uno slider Swiper per il blocco ACF Lista Partner.
 * 
 * @since Theme Territoriale 1.2.0
 */

export function initPartnerSlider() {
  if (typeof Swiper === "undefined") {
    console.warn("Swiper non disponibile per il blocco Partner!");
    return;
  }

  const sliders = document.querySelectorAll(".swiper-partners");

  if (sliders.length === 0) {
    console.warn("Nessuno slider Partner trovato nella pagina.");
    return;
  }

  sliders.forEach((slider, index) => {
    const wrapperEl = slider.closest(".blocco-acf--partners");
    const wrapperId = wrapperEl?.id || `swiper-partners-${index}`;

    // Nel caso non ci sia un ID, lo assegno (utile per la navigazione)
    if (wrapperEl && !wrapperEl.id) {
      wrapperEl.id = wrapperId;
    }
    console.log(`Inizializzazione slider Partner [${index + 1}] → ID: ${wrapperId} 👍`);

    const slides = slider.querySelectorAll(".swiper-slide");
    const enableLoop = slides.length > 1;

    // Navigation (selettori con ID del wrapper, per evitare conflitti)
    const nextElSelector = `#${wrapperId} .swiper-button-next`;
    const prevElSelector = `#${wrapperId} .swiper-button-prev`;

    // Se ci sono 0/1 slide, nascondo eventuali frecce
    const nextEl = document.querySelector(nextElSelector);
    const prevEl = document.querySelector(prevElSelector);
    if (!enableLoop) {
      if (nextEl) nextEl.style.display = "none";
      if (prevEl) prevEl.style.display = "none";
    }

    new Swiper(slider, {
      slidesPerView: 1,
      spaceBetween: 24,
      loop: enableLoop,
      speed: 600,
      autoplay: enableLoop
        ? {
          delay: 3000,
          disableOnInteraction: false,
          pauseOnMouseEnter: true,
        }
        : false,
      navigation: {
        nextEl: nextElSelector,
        prevEl: prevElSelector,
      },
      pagination: false,
      breakpoints: {
        576: { slidesPerView: 2 },
        768: { slidesPerView: 3 },
        992: { slidesPerView: 4 },
        1200: { slidesPerView: 5 },
      },
    });
  });
}
